'use strict';

exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _componentsProvider = require('./components/Provider');

exports.Provider = _interopRequire(_componentsProvider);

var _componentsConnect = require('./components/connect');

exports.connect = _interopRequire(_componentsConnect);


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux/lib/index.js
 ** module id = 30
 ** module chunks = 0
 **/